/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    getErrorDetailsFn,
    getInputFieldProps,
    onlyNumberInput,
    removeSpecialCharAndNumFn,
    safeToString,
    sliceText,
} from "../../../../utils/common";
import useAPIHandler from "../../../../hook/use-api-handler";
import { esiSchema } from "./esi-validation";
import { ESI_INITIAL_STATE } from "./esi-constant";
import { logger, safeString } from "../../../../utils/logger";


const useEsiService = ({ openSnackbar }) => {
    const [esi, setEsi] = useState(ESI_INITIAL_STATE);
    const [esiListinfo, setEsiListinfo] = useState([]);
    const [errors, setErrors] = useState({});

    const { fetchData } = useAPIHandler();

    async function esiLists() {
        try {
            const URL = "/admin/esi";
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                setEsiListinfo(result.data);
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "employee_contribution") {
            value = sliceText(onlyNumberInput(safeString(value), 150))
        }

        if (name === "employer_contribution") {
            value = sliceText(onlyNumberInput(safeString(value), 150))
        }


        setEsi((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = esiSchema.extract(name);
        const { error } = fieldSchema.validate(value);
        logger.log(error,"errorerrorerrorerrorerror")
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }
    }

    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = esiSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }



    const handleSubmit = async () => {
        try {
            const {
                employee_contribution,
                employer_contribution,
                decuction_cycle,
            } = esi;
    
            const { error } = esiSchema.validate(
                { employee_contribution, employer_contribution, decuction_cycle, state_id: 2 },
                { abortEarly: false }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            const response = await fetchData({
                url: "/admin/esi",
                method: "POST",
                data: { employee_contribution, employer_contribution, decuction_cycle, state_id: 2 },
            });
    
            if (response.status === "success") {
                setEsi(ESI_INITIAL_STATE);
                openSnackbar({ message: "ESI Created Successfully", color: "success" });
                esiLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    
    const handleUpdate = async (id) => {
        try {
            const {
                employee_contribution,
                employer_contribution,
                decuction_cycle,
            } = esi;
    
            const { error } = esiSchema.validate(
                { employee_contribution, employer_contribution, decuction_cycle, state_id: 2 },
                { abortEarly: false }
            );
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
    
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            const response = await fetchData({
                url: `/admin/esi/${id}`,
                method: "PUT",
                data: { employee_contribution, employer_contribution, decuction_cycle, state_id: 2 },
            });
    
            if (response.status === "success") {
                setEsi(ESI_INITIAL_STATE);
                openSnackbar({ message: "ESI Updated Successfully", color: "success" });
                esiLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    
    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = {};
            error?.errors?.reduce((acc, curr) => {
                const { field, message } = curr;

                errorsAll[field] = message;

                return acc;
            });
            openSnackbar({
                message:
                    Object.keys(errorsAll).length > 0
                        ? "Validation Error!"
                        : "Something went wrong!",
                color: "danger",
            });
            setErrors(errorsAll);
        }
        else if (error?.type === "GeneralError") {
            const backendMessage = typeof error.message === "string"
                ? error.message
                : "An unexpected error occurred.";

            openSnackbar({
                message: backendMessage,
                color: "danger",
            });
        }
        logger.log(error)
    };

    useEffect(() => {
        esiLists()
    }, []);



    return {
        esiListinfo,
        setEsi,
        esi,
        errors, 
        setErrors,
        handleBlurFn,
        handleChange,
        handleSubmit,
        handleUpdate
    };
};

export default useEsiService;